export function packageMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      packageId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdatePackageId(json) {
  return {
    data: {...json, id: json.objectId},
  };
}
export function fixGetManyPackages(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      categoryId: resource.objectId,
    })),
  };
}

export function fixCreatePackageId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function packageMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, packageId: json.result.objectId},
  };
}